var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaneInbound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6191",
    "data-name": "Rectangle 6191",
    width: 31.327,
    height: 33.201,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25396",
    "data-name": "Group 25396",
    transform: "translate(-132 -472)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6193",
    "data-name": "Rectangle 6193",
    width: 50,
    height: 50,
    transform: "translate(132 472)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25395",
    "data-name": "Group 25395",
    transform: "translate(172.327 513.203) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25394",
    "data-name": "Group 25394",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13067",
    "data-name": "Path 13067",
    d: "M26.413,16.191H8.318C8.234,16.191,0,15.677,0,13.41s8.233-2.781,8.317-2.781h18.1c1.222,0,4.912.987,4.912,2.781s-3.69,2.781-4.912,2.781M1.383,13.41c.87.685,5.378,1.481,6.935,1.481h18.1c1.308,0,3.612-1.022,3.612-1.481s-2.3-1.481-3.612-1.481H8.318c-1.556,0-6.065.8-6.935,1.481",
    transform: "translate(0 3.189)",
    fill: "#0d1b42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13068",
    "data-name": "Path 13068",
    d: "M17.949,15.119a.651.651,0,0,1-.559-.317L9.559,1.7l-.45.449,2.257,7.784a.7.7,0,0,1,.025.181v4.357a.65.65,0,1,1-1.3,0V10.2L7.753,2.141A.653.653,0,0,1,7.918,1.5L9.228.19A.661.661,0,0,1,9.769.005a.651.651,0,0,1,.477.311l8.261,13.82a.65.65,0,0,1-.558.983",
    transform: "translate(2.319 0)",
    fill: "#0d1b42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13069",
    "data-name": "Path 13069",
    d: "M9.667,29.028a.654.654,0,0,1-.46-.19L7.9,27.527a.651.651,0,0,1-.165-.64l2.338-8.063V14.557a.65.65,0,0,1,1.3,0v4.359a.712.712,0,0,1-.025.181L9.087,26.879l.45.45L17.37,14.223a.65.65,0,1,1,1.117.667L10.224,28.711a.649.649,0,0,1-.477.312.559.559,0,0,1-.081.005",
    transform: "translate(2.312 4.173)",
    fill: "#0d1b42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13070",
    "data-name": "Path 13070",
    d: "M3.37,19.665a.629.629,0,0,1-.228-.042l-1.491-.558a.648.648,0,0,1-.4-.766l1.117-4.467a.65.65,0,1,1,1.261.315l-.976,3.9.5.186,3.08-4a.65.65,0,0,1,1.03.793L3.885,19.412a.648.648,0,0,1-.515.254",
    transform: "translate(0.369 4.002)",
    fill: "#0d1b42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13071",
    "data-name": "Path 13071",
    d: "M3,13.656a.647.647,0,0,1-.629-.493L1.25,8.7a.65.65,0,0,1,.4-.767l1.491-.558a.651.651,0,0,1,.744.212L7.26,11.963a.65.65,0,1,1-1.03.793l-3.081-4-.5.187.975,3.9a.648.648,0,0,1-.472.788.67.67,0,0,1-.159.02",
    transform: "translate(0.369 2.199)",
    fill: "#0d1b42"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneInbound);
export default __webpack_public_path__ + "static/media/plane-inbound.b06cd7941592c3af6bb221b614e4dce6.svg";
export { ForwardRef as ReactComponent };